// extracted by mini-css-extract-plugin
module.exports = {"openModalBtn":"ChangeClinic_openModalBtn__10qqG","footer":"ChangeClinic_footer__3ruiW"};